export default __webpack_public_path__ + "static/media/vignetteHeartMarly.c8f3e3a6.jpg";